// eslint-disable-next-line max-classes-per-file
import type { DisplayNameInterface } from "@/app/GoApi/destination/GetAirportDisplayName/interfaces/DisplayNameInterface";

export interface RequestFlightSeoInterface {
  countrySlug: string;
  citySlug?: string;
  areaSlug?: string;
  limit?: number;
  page?: number;
}

export interface RequestFlightSeoDetailBySlugInterface {
  countrySlug: string;
  citySlug: string;
  flightSlug: string;
}

export interface ResponseFlightSeoDetailBySlugInterface {
  status: boolean;
  flightDetail: FlightSeoDetail;
}

export interface FlightSeoDetail {
  countryName: string;
  cityName: string;
  countrySlug: string;
  citySlug: string;
  fromAirportCode: string;
  toAirportCode: string;
  flightOfferName: string;
  flightSlug: string;
  flightIntro: string;
  flightDescription: string;
  isGreenCertificate?: boolean;
  photoPath: string;
  flightType: string;
  airlineLogo: string;
  price: number;
}

export interface HotelData {
  breadcrumbs: HotelDataBreadcrumbs;
  allCity: HotelDataAllCity[];
  allArea: string[];
  latitude: string;
  longitude: string;
  total: number;
  page: number;
  limit: number;
  hotels: HotelDetail[];
}

export interface HotelDataBreadcrumbs {
  countryName: string;
  countrySlug: string;
  cityName?: string | null;
  citySlug?: string | null;
  areaName?: string | null;
  areaSlug?: string | null;
}

export interface HotelDataAllCity {
  name: string;
  slug: string;
}

export interface HotelDetail {
  id: number;
  hotelName: string;
  hotelSlug: string;
  hotelStar: number;
  countryName: string;
  countrySlug: string;
  countryUrl: string;
  cityName: string;
  citySlug: string;
  cityUrl?: string | null;
  areaName: string;
  areaSlug: string;
  areaUrl?: string | null;
  latitude: number;
  isGreenCertificate?: boolean;
  longitude: number;
  isFreeWifi: number;
  isFreeParking: number;
  isFavourite: number;
  facilities?: string[];
  facilitiesDetail?: FacilitiesDetail[];
  images: string[];
  review: Review;
}

export interface FacilitiesDetail {
  groupId: number;
  groupName: string;
  details: Detail[];
}

export interface Detail {
  id: number;
  name: string;
  image: string;
}

export interface Review {
  rating: any;
  text_rating_detail: any;
  num_reviews: any;
}

export interface AirlineDescription {
  airlineName: string;
  airlineCode: string;
  airlineSlug: string;
}
export interface ResponseFlightSeoInterface {
  breadcrumbs: Breadcrumbs;
  total: number;
  totalPage: number;
  flightOffer: FlightOffer[];
  hotelData: HotelData;
  status: boolean;
  othersCity: CityInCountry[];
  flightsCity: FlightsCity[];
  airlines: AirlineDescription[];
  cityDescription: CityDescription;
  airportCity: AirportCity[];
  airportInCountry: AirportInCountry[];
  cityInCountry: CityInCountry[];
  aboutCountry?: AboutCountry;
  hasAirport?: boolean;
}

export interface AboutCountry {
  countryName?: string;
  latitude?: string;
  longitude?: string;
  countrySlug?: string;
}
export interface Breadcrumbs {
  countryName: string;
  countrySlug: string;
  cityName: string;
  citySlug: string;
}

export interface FlightOffer {
  flightOfferId: string;
  price: number;
  flightType: string;
  dateSearchDeparture: string;
  dateSearchReturn: string;
  ticketingPeriod: string;
  travelPeriod: string;
  slug: string;
  intro: string;
  photoPath: string;
  fromAirportCode: string;
  toAirportCode: string;
  airlineSlug: string;
  airlineName: string;
  cityFromName: string;
  cityToName: string;
  cityFromSlug?: string;
  cityToSlug?: string;
  airlineLogo?: string;
}

export interface FlightsCity {
  areaName: string;
  areaSlug: string;
}

export interface CityDescription {
  cityName: string;
  countryName: string;
  countrySlug: string;
  citySlug: string;
  cityLatitude: string;
  cityLongitude: string;
}

export interface AirportCity {
  airportName: string;
  airportCode: string;
  airportSlug: string;
}

export interface AirportInCountry {
  AirportName: string;
  AirportCode: string;
}

export interface CityInCountry {
  citySlug: string;
  cityName: string;
}

export interface ResponseSearchPanelRecommendDisplayNameInterface {
  status: boolean;
  displayName: DisplayNameInterface[];
}

export class ResponseFlightSeoClass {
  breadcrumbs: Breadcrumbs;

  total: number;

  totalPage: number;

  flightOffer: FlightOffer[];

  hotelData: HotelData;

  status: boolean;

  othersCity: CityInCountry[];

  flightsCity: FlightsCity[];

  airlines: AirlineDescription[];

  cityDescription: CityDescription;

  airportCity: AirportCity[];

  airportInCountry: AirportInCountry[];

  cityInCountry: CityInCountry[];

  aboutCountry?: AboutCountry;

  hasAirport?: boolean;

  isGreenCertificate?: boolean;

  constructor(data: any) {
    this.breadcrumbs = data.breadcrumbs || {};
    this.total = data.total || 0;
    this.totalPage = data.totalPage || 0;
    this.flightOffer = data.flightOffer || [];
    this.hotelData = data.hotelData || {};
    this.status = data.status || false;
    this.othersCity = data.othersCity || [];
    this.flightsCity = data.flightsCity || [];
    this.airlines = data.airlines || [];
    this.cityDescription = data.cityDescription || {};
    this.airportCity = data.airportCity || [];
    this.airportInCountry = data.airportInCountry || [];
    this.cityInCountry = data.cityInCountry || [];
    this.aboutCountry = data.aboutCountry || undefined;
    this.hasAirport = data.hasAirport || undefined;
    this.isGreenCertificate = data.isGreenCertificate || false;
  }
}

class FlightSeoDetailClass {
  countryName: string;

  cityName: string;

  countrySlug: string;

  citySlug: string;

  fromAirportCode: string;

  toAirportCode: string;

  flightOfferName: string;

  flightSlug: string;

  flightIntro: string;

  flightDescription: string;

  isGreenCertificate: boolean | undefined;

  photoPath: string;

  flightType: string;

  airlineLogo: string;

  price: number;

  constructor(response: any) {
    this.countryName = response.countryName || "";
    this.cityName = response.cityName || "";
    this.countrySlug = response.countrySlug || "";
    this.citySlug = response.citySlug || "";
    this.fromAirportCode = response.fromAirportCode || "";
    this.toAirportCode = response.toAirportCode || "";
    this.flightOfferName = response.flightOfferName || "";
    this.flightSlug = response.flightSlug || "";
    this.flightIntro = response.flightIntro || "";
    this.flightDescription = response.flightDescription || "";
    this.isGreenCertificate = response.isGreenCertificate || false;
    this.photoPath = response.photoPath || "";
    this.flightType = response.flightType || "";
    this.airlineLogo = response.airlineLogo || "";
    this.price = response.price || 0;
  }
}

export class ResponseFlightSeoDetailBySlugClass {
  status: boolean;

  flightDetail: FlightSeoDetail;

  constructor(response: any) {
    this.status = response.status || false;
    this.flightDetail = new FlightSeoDetailClass(response.flightDetail || {});
  }
}

export interface RequestFareUpsell {
  keyDeparture: string;
  keyReturn: string;
  keySearch: string;
  keySearchDatetime: string;
}
